// extracted by mini-css-extract-plugin
export default {"templatePage":"templatePage_KtbAu","mainContent":"mainContent_VV7vr"};